/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _default = function _default(_ref) {
  var count = _ref.count,
      initialOffset = _ref.initialOffset,
      rowHeightManager = _ref.rowHeightManager,
      initialScrollTop = _ref.initialScrollTop;
  var result = (0, _toConsumableArray2.default)(Array(count)).map(function (_, i) {
    var rowHeight = rowHeightManager.getRowHeight(i);
    var top = rowHeightManager.getRowOffset(i);
    var offset = top + initialOffset - (initialScrollTop || 0);
    var bottom = offset + rowHeight;
    var result = {
      top: offset,
      bottom: bottom,
      height: rowHeight,
      index: i
    };
    return result;
  });
  return result;
};

exports.default = _default;